import { render, staticRenderFns } from "./home-slider.vue?vue&type=template&id=32eb38d1&"
import script from "./home-slider.vue?vue&type=script&lang=js&"
export * from "./home-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports